import React from 'react';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';

export function Programme({ storefrontSettings, onScrollTo }) {
    const [programmeRef, programmeRevealed] = useScrollReveal({ threshold: 0.15 });
    const [cardRef, cardRevealed] = useScrollReveal({ threshold: 0.15 });

    const handleScroll = (id) => {
        onScrollTo?.(id);
    };

    const defaultFeatures = [
        'Weekly 1:1 Zoom calls',
        'Tailored worksheets',
        'Journaling prompts',
        'Voice note/DM support',
        'Personalised meditation',
        'Feminine energy tools',
        'Nervous system regulation',
        'Cultural conditioning healing'
    ];

    return (
        <section id="programme" className="py-24 bg-[#fdfbf7]">
            <div className="max-w-5xl mx-auto px-6">
                <div ref={programmeRef} className={`text-center mb-16 ${programmeRevealed ? 'reveal revealed' : 'reveal'}`}>
                    <h2 className="text-4xl font-serif text-gray-800 mb-4">{storefrontSettings?.programmeTitle || '12-Week 1:1 Coaching Programme'}</h2>
                    {storefrontSettings?.programmeDescription && (
                        <p className="text-gray-500 max-w-2xl mx-auto text-lg">
                            {storefrontSettings.programmeDescription}
                        </p>
                    )}
                </div>

                <div ref={cardRef} className={`bg-white rounded-3xl shadow-xl overflow-hidden border border-[#f3e6d5] flex flex-col md:flex-row card-hover ${cardRevealed ? 'reveal revealed reveal-delay-1' : 'reveal'}`}>
                    <div className="md:w-2/3 p-10 md:p-12">
                        <h3 className="text-2xl font-serif text-gray-800 mb-6">What's Included:</h3>
                        {Array.isArray(storefrontSettings?.programmeFeatures) && storefrontSettings.programmeFeatures.length > 0 ? (
                            <div className="grid sm:grid-cols-2 gap-6">
                                {storefrontSettings.programmeFeatures.map((feature, i) => (
                                    <div key={i} className="flex items-start group hover:text-[#d48c95] transition-colors">
                                        <CheckCircle size={20} className="text-[#d48c95] mt-1 mr-3 flex-shrink-0 group-hover:scale-110 transition-transform" />
                                        <span className="text-gray-700 group-hover:text-[#d48c95]">{feature}</span>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="grid sm:grid-cols-2 gap-6">
                                {defaultFeatures.map((feature, i) => (
                                    <div key={i} className="flex items-start group hover:text-[#d48c95] transition-colors">
                                        <CheckCircle size={20} className="text-[#d48c95] mt-1 mr-3 flex-shrink-0 group-hover:scale-110 transition-transform" />
                                        <span className="text-gray-700 group-hover:text-[#d48c95]">{feature}</span>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <div className="md:w-1/3 bg-[#fae1e5]/30 p-10 flex flex-col justify-center items-center border-t md:border-t-0 md:border-l border-[#f3e6d5]">
                        <div className="text-center">
                            {storefrontSettings?.programmeBadge && (
                                <span className="inline-block px-4 py-1 bg-[#d48c95] text-white text-xs font-bold uppercase tracking-wider rounded-full mb-4">
                                    {storefrontSettings.programmeBadge}
                                </span>
                            )}
                            {storefrontSettings?.programmePrice && (
                                <div className="text-5xl font-serif text-gray-800 mb-2">£{storefrontSettings.programmePrice}</div>
                            )}
                            {storefrontSettings?.programmeOriginalPrice && storefrontSettings?.programmePriceNote && (
                                <div className="text-gray-500 line-through mb-8 text-sm">
                                    £{storefrontSettings.programmeOriginalPrice} ({storefrontSettings.programmePriceNote})
                                </div>
                            )}
                            <button onClick={() => handleScroll('booking')} className="w-full py-4 bg-[#c5a059] text-white rounded-xl font-medium shadow-md hover:bg-[#b08e4d] hover:shadow-xl transition-all duration-300 mb-4 hover-lift button-press focus-ring group">
                                <span className="flex items-center justify-center">
                                    Apply Now
                                    <ArrowRight size={18} className="ml-2 group-hover:translate-x-1 transition-transform" />
                                </span>
                            </button>
                            {storefrontSettings?.programmePaymentNote && (
                                <p className="text-xs text-gray-500 text-center">{storefrontSettings.programmePaymentNote}</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Programme;
